import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './EduCategory.module.less';
import ScrollTop from '../../../components/ScrollTop/ScrollTop';
import InfinteScroll from '../../../components/InfinteScroll/GridInfinteScroll';
import {
  getEducationCategoryTags,
  getEducationCategoryGradelist,
  setEducationCategoryError,
} from '../../../actions/education';
import eduBlank from '../../../static/edu_blank.svg';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import Loading from '../../../components/Loading/Loading';
import EduCard from '../../../components/EduCard/EduCard';
import { logging, logPostInfo } from '../../../actions/log';
import qs from 'query-string';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { education } from '../../../constants/storageKeys';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const SelectEductionCategory = createSelector(
  state => state.education,
  educations => educations.category,
);

function EduCategory() {
  const [activeStage, setActiveStage] = useState(null);
  const [stages, setStages] = useState(null);
  const [activeGrade, setActiveGrade] = useState(null);
  const [grades, setGrades] = useState(null);
  const [activeSubject, setActiveSubject] = useState(null);
  const [subjects, setSubjects] = useState(null);
  const [activePrice, setActivePrice] = useState(null);
  const [prices, setPrices] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initTime, setInitTime] = useState(null);

  const { tags, gradeList = [], pagenation, error } = useSelector(SelectEductionCategory);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [search, setSearch] = useState(qs.parse(location.search));
  const logInfoData = useSelector(selectLogInfo);
  // 浏览时长打桩
  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Edu_Classify`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
  };
  useEffect(() => {
    setInitTime(+new Date());
    return () => {
      leaveTimeLog();
    };
  }, []);
  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });
  const pvLog = () => {
    // 打桩-记录展现当前页面
    dispatch(
      logging({
        category: 'P',
        action: 'Edu_Classify',
        label: '',
        param2: {
          source: `Edu_Classify`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Edu_Classify',
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  };
  useEffect(() => {
    pvLog();
  }, []);
  useActivate(() => {
    pvLog();
  });
  const getData = refresh => {
    if (activeStage && activeGrade && activeSubject) {
      dispatch(
        getEducationCategoryGradelist({
          refresh,
          gradeId: activeGrade,
          limit: 24,
          phaseId: activeStage,
          skip:
            pagenation.gradeId === activeGrade &&
            pagenation.subjectId === activeSubject &&
            pagenation.phaseId === activeStage &&
            pagenation.priceId === activePrice &&
            !refresh
              ? (gradeList && gradeList.length) || 0
              : 0,
          subjectId: activeSubject,
          priceId: activePrice,
        }),
      );
    }
    if (refresh) {
      dispatch(
        logging({
          category: 'C',
          action: 'Edu_Classify',
          label: '',
          param2: {
            source: `Edu_Classify||${activeStage}||${activeGrade}||${activeSubject}||${activePrice}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            age_period: localStorage.getItem(education.EDUSTAGE),
          },
        }),
      );
    }
  };

  const initPage = () => {
    if (!tags || tags.length === 0) {
      dispatch(getEducationCategoryTags());
    } else {
      if (stages != null) {
        setStages(state => [...state]);
      }
      setActiveStage((search && search.phaseId) || (tags[0] && tags[0].phaseId));
      setSearch(state => ({ ...state, phaseId: null }));
    }
    // 页面性能优化操作
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
      clearTimeout(timer);
    }, 200);
  };
  // 页面初始化
  useEffect(() => {
    if (error) {
      dispatch(setEducationCategoryError(false));
      history.replace(`${CONTEXT}/error`);
    }
  }, [error]);

  useEffect(() => {
    initPage();
  }, []);
  useActivate(() => {
    if (history.action === 'PUSH') {
      initPage();
    }
  });

  // 根据选中的标签获取课程列表
  useEffect(() => {
    if (activeSubject && activePrice) {
      getData(true);
    }
  }, [activeSubject, activePrice]);
  useEffect(() => {
    if (tags) {
      setStages(tags);
      setActiveStage((search && search.phaseId) || (tags[0] && tags[0].phaseId));
      setSearch(state => ({ ...state, phaseId: null }));
    }
  }, [tags]);

  useEffect(() => {
    if (stages && activeStage) {
      const targetGrades = stages.find(item => item.phaseId === activeStage);
      if (targetGrades) {
        setActiveGrade(
          (search && search.gradeId) ||
            (targetGrades.gradeList &&
              targetGrades.gradeList[0] &&
              targetGrades.gradeList[0].gradeId),
        );
        setSearch(state => ({ ...state, gradeList: null }));
        setGrades([...targetGrades.gradeList] || []);
      }
    }
  }, [activeStage, stages]);

  useEffect(() => {
    if (grades && activeGrade) {
      const targetSubjects = grades.find(item => item.gradeId === activeGrade);
      if (targetSubjects) {
        setActiveSubject(
          (search && search.subjectId) ||
            (targetSubjects.subjectList &&
              targetSubjects.subjectList[0] &&
              targetSubjects.subjectList[0].subjectId),
        );
        setSearch(state => ({ ...state, subjectId: null }));
        setSubjects([...targetSubjects.subjectList] || []);
      }
    }
  }, [activeGrade, grades]);
  useEffect(() => {
    if (subjects && activeSubject) {
      const targetprices = subjects.find(item => item.subjectId === activeSubject);
      if (targetprices) {
        setActivePrice(state => {
          const keepActivePrice =
            targetprices.priceList && targetprices.priceList.find(item => item.priceId === state);
          return (
            (search && search.priceId) ||
            (keepActivePrice && keepActivePrice.priceId) ||
            (targetprices.priceList &&
              targetprices.priceList[0] &&
              targetprices.priceList[0].priceId)
          );
        });
        setSearch(state => ({ ...state, priceId: null }));
        setPrices((targetprices.priceList && [...targetprices.priceList]) || []);
      }
    }
  }, [activeSubject, subjects]);

  const handleStage = param => () => {
    setActiveStage(param);
  };

  const handleGrade = param => () => {
    setActiveGrade(param);
  };

  const handleSubject = param => () => {
    setActiveSubject(param);
  };

  const handlePrice = param => () => {
    setActivePrice(param);
  };

  const firstHeight =
    33 *
      (Math.ceil((stages && stages.length / 10) || 0) +
        Math.ceil((grades && grades.length / 10) || 0) +
        Math.ceil((subjects && subjects.length / 10) || 0) +
        Math.ceil((prices && prices.length / 10) || 0)) +
    263 +
    24;

  const loadMore = () => {
    getData();
  };

  const Header = () => {
    return (
      <div className={styles.category}>
        <div className={styles.category_classify}>
          {stages && stages.length > 0 && (
            <div className={classNames(styles.start_grid)}>阶段：</div>
          )}
          {stages &&
            stages.length > 0 &&
            stages.map((item, index) => {
              return (
                <div
                  key={`${index}_${item.phaseId}`}
                  className={classNames(styles.common_grid, {
                    [styles.active]: item.phaseId === activeStage,
                  })}
                  onClick={handleStage(item.phaseId)}
                >
                  {item.phaseName}
                </div>
              );
            })}
        </div>
        <div className={styles.category_classify}>
          {grades && grades.length > 0 && <div className={styles.start_grid}>年级：</div>}
          {grades &&
            grades.length > 0 &&
            grades.map((item, index) => {
              return (
                <div
                  key={`${index}_${item.gradeId}`}
                  className={classNames(styles.common_grid, {
                    [styles.active]: item.gradeId === activeGrade,
                  })}
                  onClick={handleGrade(item.gradeId)}
                >
                  {item.gradeName}
                </div>
              );
            })}
        </div>
        <div className={styles.category_classify}>
          {subjects && subjects.length > 0 && <div className={styles.start_grid}>学科：</div>}
          {subjects &&
            subjects.length > 0 &&
            subjects.map((item, index) => {
              return (
                <div
                  key={`${index}_${item.subjectId}`}
                  className={classNames(styles.common_grid, {
                    [styles.active]: item.subjectId === activeSubject,
                  })}
                  onClick={handleSubject(item.subjectId)}
                >
                  {item.subjectName}
                </div>
              );
            })}
        </div>
        {prices && prices.length > 0 && (
          <div className={styles.category_classify}>
            <div className={styles.start_grid}>资费：</div>
            {prices &&
              prices.length > 0 &&
              prices.map((item, index) => {
                return (
                  <div
                    key={`${index}_${item.subjectId}`}
                    className={classNames(styles.common_grid, {
                      [styles.active]: item.priceId === activePrice,
                    })}
                    onClick={handlePrice(item.priceId)}
                  >
                    {item.priceName}
                  </div>
                );
              })}
          </div>
        )}
      </div>
    );
  };
  if (!tags || tags.length === 0 || (loading && history.action !== 'POP')) {
    return (
      <div className={styles.eduCategory}>
        <div className={styles.loading}>
          <Loading />
        </div>
      </div>
    );
  }

  // if (pagenation && pagenation.loading) {
  //   return (
  //     <div className={styles.eduCategory}>
  //       <div className={styles.eduCategory_container}>
  //         <div className={styles.InfinteScroll}>
  //           <Header />
  //           <div className={styles.loading_content}>
  //             <Loading />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (gradeList && gradeList.length === 0 && pagenation.count === 0) {
    return (
      <div className={styles.eduCategory}>
        <div className={styles.eduCategory_container}>
          <div className={styles.InfinteScroll}>
            <Header />
            <img className={styles.nodata} src={eduBlank} alt=""></img>
            <div className={styles.nodata_text}>
              目前还没有相关的课程哦！
              <Link to={`${CONTEXT}/education/recommend`} className={styles.link}>
                随便逛逛
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.eduCategory}>
      <div className={styles.eduCategory_container}>
        <InfinteScroll
          dataSource={[...gradeList]} // 数据集
          count={pagenation.count}
          gap={15}
          columnWidth={250}
          minimumBatchSize={3} // 一行最多统一时间加载个数 默认10
          threshold={3} // 预加载个数
          getItemSize={index => (index !== 0 ? 263 : firstHeight)} // 行高
          loadData={loadMore}
          column={3}
          template={(item, index) => {
            return (
              <div
                className={classNames(styles.zt_card, {
                  [styles.zt_card_center]: index % 3 === 1,
                })}
              >
                <EduCard
                  data={item}
                  tag="left"
                  log={{
                    source: `Edu_Classify||${activeStage}||${activeGrade}||${activeSubject}`,
                  }}
                  hasDelete={false}
                  type="reading"
                ></EduCard>
              </div>
            );
          }}
          tpl={Header}
        />
        {gradeList && gradeList.length === 0 && pagenation.count !== 0 && (
          <div>
            <Loading />
          </div>
        )}
      </div>

      <ScrollTop />
    </div>
  );
}

export default () => (
  <KeepAlive name="educategory">
    <EduCategory></EduCategory>
  </KeepAlive>
);
